const log1024 = Math.log(1024);
const sizePowers = ['B', 'kB', 'MB', 'GB', 'TB'];

export function displayAttachmentSize(size: number | null | undefined) {
  if (size == null) return 'N.A.';
  const index = size === 0 ? 0 : Math.floor(Math.log(size) / log1024);
  return `${(size / Math.pow(1024, index)).toFixed(2)} ${sizePowers[index]}`;
}
